<template>
  <div class="add-combo">
    <div class="data-form tuolele-main-box">
      <div class="data-form-title">设置套餐基本信息</div>
      <div class="form-row">
        <div class="form-input important">
          <span>套餐分类</span>
          <el-select v-model="nowType" placeholder="请选择">
            <!-- <el-option
              v-for="item in comboTypes"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option> -->
            <el-option label="体验课时" value="1" />
            <el-option label="新增套餐（普通套餐）" value="2" />
            <el-option
              v-if="type == 1"
              label="新增套餐（畅享套餐）"
              value="3"
            />
            <el-option label="研学套餐" value="4" />

          </el-select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-input important">
          <span>套餐名称</span>
          <el-input
            v-model="item_title"
            size="large"
            placeholder="请输入套餐名称"
            style="width:800px"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-input important">
          <span>购买上限</span>
          <el-input
            v-model="limited_number"
            type="number"
            size="large"
            placeholder="请输入最大购买次数"
          />
          <span>0为不限</span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">适用年级</span>
          <div class="fn-left">
            <Checkbox
              :list.sync="gradeList"
              :select-list="selectGrade"
              @updateCheck="updateGrade"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-input important">
          <span>补充协议</span>
          <el-radio v-model="is_supplementary_agreement" label="1">显示</el-radio>
          <el-radio v-model="is_supplementary_agreement" label="0">不显示</el-radio>
        </div>
      </div>
    </div>
    <tasteCombo
      v-if="nowType == 1"
      :type.sync="type"
      :item_title="item_title"
      :limited_number="limited_number"
      :is_supplementary_agreement="is_supplementary_agreement"
      :grade_id="grade_id"
    />
    <normalCombo
      v-if="nowType == 2"
      :type.sync="type"
      :item_title="item_title"
      :limited_number="limited_number"
      :is_supplementary_agreement="is_supplementary_agreement"
      :grade_id="grade_id"
    />
    <enjoyCombo
      v-if="nowType == 3"
      :type.sync="type"
      :item_title="item_title"
      :limited_number="limited_number"
      :is_supplementary_agreement="is_supplementary_agreement"
      :grade_id="grade_id"
    />
    <researchCombo
      v-if="nowType == 4"
      :type.sync="type"
      :item-title="item_title"
      :limited-number="limited_number"
      :is-supplementary-agreement="is_supplementary_agreement"
      :grade-id="grade_id"
    />
  </div>
</template>

<script>
import Checkbox from '@/components/toolbar/Checkbox.vue'
// import ShopSelect from "@/components/toolbar/ShopSelect.vue";
import tasteCombo from '@/components/combo/TasteCombo.vue'
import normalCombo from '@/components/combo/NormalCombo.vue'
import researchCombo from '@/components/combo/ResearchCombo.vue'
import enjoyCombo from '@/components/combo/EnjoyCombo.vue'
export default {
  name: 'AddCombo',
  components: {
    // ShopSelect,
    tasteCombo,
    normalCombo,
    enjoyCombo,
    Checkbox,
    researchCombo
  },
  data() {
    return {
      comboTypes: [
        { text: '体验课时', value: '1' },
        { text: '新增套餐（普通套餐）', value: '2' },
        { text: '新增套餐（畅享套餐）', value: '3' }
      ],
      nowType: '1',
      item_title: '',
      type: 1,
      limited_number: 0,
      is_supplementary_agreement: '1',
      grade_id: '',
      gradeList: [
        { value: '-2', text: '幼儿园小班' },
        { value: '-1', text: '幼儿园中班' },
        { value: '1', text: '幼儿园大班' },
        { value: '2', text: '一年级' },
        { value: '3', text: '二年级' },
        { value: '4', text: '三年级' },
        { value: '5', text: '四年级' },
        { value: '6', text: '五年级' },
        { value: '7', text: '六年级' },
        { value: '8', text: '初一' },
        { value: '9', text: '初二' },
        { value: '10', text: '初三' }

      ],
      selectGrade: []
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.type = this.$route.query.type
  },
  methods: {
    updateGrade(val) {
      this.selectGrade = val
      this.grade_id = val.join(',')
    }
  }
}
</script>
<style lang="scss" scoped>
.add-combo {
  .data-form {
    .form-row {
      .form-input {
        .shop-select {
          overflow: hidden;
        }
      }
    }
    .data-form-title {
      font-size: 20px;
      margin-bottom: 30px;
      color: $color_black;
    }
  }
}
</style>
